<template>
  <login-content
    id-type="student"
    id-placeholder="學生學號"
    id-name="student_id"
    id-icon="user-graduate"
    password-name="student_password"
    register-title="請輸入您的學校信箱"
    forget-password-title="忘記密碼？請輸入你的學號"
    @login:submitted="studentLogin"
    @signup:submitted="studentSignUp"
    @password:forget="studentForgetPassword"
  >
    <input-group>
      <template slot="append">
        <span
          aria-hidden="true"
          class="input-group-text text-muted"
        >
          ＠mail.ntust.edu.tw
        </span>
      </template>
      <form-input
        v-model="studentId"
        placeholder="學號"
      />
    </input-group>
  </login-content>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import InputGroup from '~components/common/form/input/Group'
import LoginContent from '~components/pages/login/LoginContent'
import FormInput from '~components/common/form/input'
export default {
  name: 'StudentLoginContent',
  components: {
    LoginContent,
    InputGroup,
    FormInput
  },
  computed: {
    ...mapGetters('pages/students', [
      'currentStudentReminderGetter',
    ]),
  },
  data () {
    return {
      studentId: ''
    }
  },
  methods: {
    ...mapActions('auth', [
      'userLogin',
      'userSignUp',
      'userForgetPassword',
    ]),
    ...mapActions('layouts', [
      'newToast',
    ]),
    ...mapActions('pages/students', [
      'getStudentReminder',
    ]),
    async studentLogin (data) {
      await this.userLogin({
        type: 'student',
        data
      });
      await this.getStudentReminder();
      [...this.currentStudentReminderGetter].forEach(toast => {
        this.newToast({
          variant: toast.alert_type,
          title: '提醒你',
          message: toast.message,
        });
      });
    },
    studentSignUp () {
      this.userSignUp({
        type: 'student',
        account: this.studentId
      })
    },
    studentForgetPassword () {
      this.userForgetPassword({
        type: 'student',
        account: this.studentId
      })
    }
  }
}
</script>
